import { AppImages } from "app/appImages";
import { GenericAbortSignal } from "axios";
import { AutoCompleteDataModel, AutoCompleteSuggestions, MprcAutoComplete } from "components/MprcAutoComplete";
import { IAutoCompleteProps } from "components/MprcAutoComplete/AutoComplete";
import { isCanceledError, useCoreApi } from "providers/CoreApiProvider";
import { UserAutoCompleteQueryParams } from "views/foundation/user/components/UserAutoComplete";

////////////////////////////////////////////////////////////////////////////

interface IProps {
    channelId: string;
    onGetDataCustom?: (data: UserAutoCompleteQueryParams, signal: GenericAbortSignal | undefined) => Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>;
}

type Props = IProps & Omit<IAutoCompleteProps, 'onGetSuggestions' | 'emptyThumbnail'>;

////////////////////////////////////////////////////////////////////////////

/**
 * Auto complete Membros do Canal
 * @param props
 */
export const ChannelUsersMembersAutoComplete: React.FC<Props> = (props) => {

    const api = useCoreApi();
    const { channelId, onError, onGetDataCustom, onChange } = props;

    ///
    const getSuggestions = (searchText: string, pageNumber: number, pageSize: number, trySelectedHistory: boolean, signal: GenericAbortSignal | undefined): Promise<AutoCompleteSuggestions<AutoCompleteDataModel>> => {
        searchText = searchText.toLowerCase();

        if (onGetDataCustom != undefined) {
            return onGetDataCustom({ pageNumber, pageSize, searchText }, signal);
        } else {
            return new Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>((resolve) => {
                api.v1.knowledgeSuggestions.channelUsersMembersSuggestion({
                    searchText: searchText,
                    channelId: channelId,
                    pageNumber: pageNumber,
                    pageSize: pageSize,
                }, { signal })
                    .then(result => {
                        resolve({
                            items: result.data.items as AutoCompleteDataModel[],
                            totalRows: result.data.totalRows
                        });
                    })
                    .catch(error => {
                        if (!isCanceledError(error)) {
                            resolve({ items: [], totalRows: 0 });
                            if (onError) onError(error);
                        }
                    });
            });
        }
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcAutoComplete
            {...props}
            onChange={onChange}
            emptyThumbnail={AppImages.UserThumbnail}
            onGetSuggestions={getSuggestions}
        />
    );
};
